/**
 * Helper function to get a class name from a styles object.
 * @param defaultClassName - The default class name to use if no styles are provided.
 * @param styles - The styles object to use to get the class name.
 * @returns The class name from the styles object, or the default class name if no styles are provided.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getClassName", {
    enumerable: true,
    get: function() {
        return getClassName;
    }
});
function getClassName(defaultClassName, styles) {
    return (styles === null || styles === void 0 ? void 0 : styles[defaultClassName]) || defaultClassName;
}

//# sourceMappingURL=helpers.js.map